"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FavouriteAssessmentsChanged = void 0;
const wishlist_event_1 = require("./wishlist-event");
class FavouriteAssessmentsChanged extends wishlist_event_1.WishlistEvent {
    constructor(userId, studyId, assessments, eventId, stateHash, timestamp, isLocal) {
        super(timestamp);
        this.userId = userId;
        this.studyId = studyId;
        this.assessments = assessments;
        this.eventId = eventId;
        this.stateHash = stateHash;
        this.timestamp = timestamp;
        this.isLocal = isLocal;
        this.eventType = FavouriteAssessmentsChanged.EventType;
        this.eventVersion = '1.0.0';
    }
    static create(userId, studyId, assessments, stateHash, timestamp = new Date(), isLocal) {
        return new FavouriteAssessmentsChanged(userId, studyId, assessments, wishlist_event_1.WishlistEvent.generateId(), stateHash, timestamp, isLocal);
    }
}
exports.FavouriteAssessmentsChanged = FavouriteAssessmentsChanged;
FavouriteAssessmentsChanged.EventType = 'FavouriteAssessmentsChanged';
